import { FunctionComponent, Suspense, lazy } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

const NuestrosTrabajos = lazy(() => import("../layout/nuestrostrabajos"));
const QuienesSomos = lazy(() => import("../layout/quienesSomos"));
const NotFound = lazy(() => import("../layout/notfound"));
const Homepage = lazy(() => import("../layout/homepage"));
const Contacto = lazy(() => import("../layout/contacto"));
import { AnimatePresence } from "framer-motion";
import GeneralLoader from "../common/loaders/generalLoader";
interface AnimatedRoutesProps {}

const AnimatedRoutes: FunctionComponent<AnimatedRoutesProps> = () => {
  const location = useLocation();
  return (
    <>
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <Suspense fallback={<GeneralLoader />}>
              <Homepage></Homepage>
            </Suspense>
          }
        />
        <Route
          path="/dist/*"
          element={
            <Suspense fallback={<GeneralLoader />}>
              <Homepage></Homepage>
            </Suspense>
          }
        />
        <Route
          path="/quienes-somos"
          element={
            <Suspense fallback={<GeneralLoader />}>
              <QuienesSomos></QuienesSomos>
            </Suspense>
          }
        />
        <Route
          path="/nuestros-trabajos"
          element={
            <Suspense fallback={<GeneralLoader />}>
              <NuestrosTrabajos></NuestrosTrabajos>
            </Suspense>
          }
        />
        <Route
          path="/contacto"
          element={
            <Suspense fallback={<GeneralLoader />}>
              <Contacto></Contacto>
            </Suspense>
          }
        />
        <Route path="*" element={<NotFound></NotFound>} />
      </Routes>
    </>
  );
};

export default AnimatedRoutes;
